import React from 'react'
import "./Sidebar.css";
import SidebarOption from './SidebarOption';
import HomeIcon from '@mui/icons-material/Home';
import SearchIcon from '@mui/icons-material/Search';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import { useDataLayerValue } from './DataLayer';
function Sidebar() {

  const [{ playlists }, dispatch] = useDataLayerValue(); 
  return (
    <div className='sidebar'>
        <img
        className="sidebar__logo"
        src="https://getheavy.com/wp-content/uploads/2019/12/spotify2019-830x350.jpg"
        alt=""
      />
      <SidebarOption Icon = {HomeIcon} title="Home"/>
      <SidebarOption Icon = {SearchIcon} title="Search"/>
      <SidebarOption Icon = {LibraryMusicIcon} title="Library"/>

      <br/>
      <strong className='sidebar__title'>PLAYLISTS</strong>
      <hr/>

      {playlists?.items?.map((playlist) => (
        <SidebarOption title={playlist.name} />
      ))}
      <SidebarOption title="Aman's FAV"/>
      <SidebarOption title="Wakhra Swag"/>
      <SidebarOption title="Behan di"/>
      <SidebarOption title="Birthday Bash"/>
      <SidebarOption title="Party time"/>
      <SidebarOption title="Late Night Mood"/>
      <SidebarOption title="Satnam Waheguru"/>
      <SidebarOption title="Fatte Chak de"/>
      <SidebarOption title="Fuck Off"/>
      {/* <SidebarOption title="Vadayian ji"/> */}
      

    </div>
  )
}

export default Sidebar;